import { OsAppType, OS } from '@/utils';
import eventsDefinition from './eventsDefinition';

const modifierKeysMap = {
  win: {
    ctrlKey: 'Ctrl + ',
    metaKey: 'Windows + ',
    altKey: 'Alt + ',
    shiftKey: 'Shift + ',
  },
  mac: {
    ctrlKey: 'Ctrl',
    metaKey: '⌘',
    altKey: 'Alt',
    shiftKey: 'Shift',
  },
  linux: {
    ctrlKey: 'Ctrl + ',
    metaKey: '',
    altKey: 'Alt + ',
    shiftKey: 'Shift + ',
  },
};

// Returns string for the shortcut;
// Depends on OS and event:
// TODO: We still need to figure out how to gen string for all Cases.
// This works for modifiers with a keyCode.
function getShortcutString(event) {
  const { modifiers, keyCodeForEventString } = event;
  if (!keyCodeForEventString) {
    return '';
  }
  let shortcutString = '';
  modifiers.forEach(mod => {
    if (!modifierKeysMap[OS][mod]) {
      return;
    }
    shortcutString += `${modifierKeysMap[OS][mod]}`;
  });
  shortcutString += String.fromCharCode(keyCodeForEventString);

  return shortcutString;
}

function allEvents() {
  const events = {};
  for (let i = 0; i < eventsDefinition.length; i += 1) {
    const event = eventsDefinition[i];
    if (event[OsAppType]) {
      events[event.id] = {
        id: event.id,
        description: event.description,
        shortcutString: getShortcutString(event[OsAppType]),
        _props: event[OsAppType],
      };
    }
  }
  return events;
}

export default allEvents();



// WEBPACK FOOTER //
// ./src/utils/KeyboardShortcuts/events.js